import React, { createContext, useContext, useState, useEffect } from 'react';
import companySettingsService from '../services/companySettingsService';

const CompanySettingsContext = createContext(null);

export const useCompanySettings = () => {
  const context = useContext(CompanySettingsContext);
  if (!context) {
    throw new Error('useCompanySettings must be used within CompanySettingsProvider');
  }
  return context;
};

export const CompanySettingsProvider = ({ children }) => {
  const [companySettings, setCompanySettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadCompanySettings();
  }, []);

  const loadCompanySettings = async () => {
    try {
      setLoading(true);
      setError(null);
      const settings = await companySettingsService?.getActiveCompanySettings();
      
      if (settings) {
        setCompanySettings(settings);
      } else {
        // No settings found, use defaults
        console.warn('No company settings found, using defaults');
        setCompanySettings({
          companyName: 'Pacific RBS Ltd',
          companyLegalName: 'Pacific RBS Limited',
          companyAbbreviation: 'PRBS',
          primaryColor: '#3b82f6',
          secondaryColor: '#10b981'
        });
      }
    } catch (err) {
      console.warn('Failed to load company settings (using defaults):', {
        message: err?.message || 'Unknown error',
        details: err?.details || '',
        hint: err?.hint || '',
        code: err?.code || ''
      });
      
      setError(err?.message || 'Failed to load company settings');
      
      // Set default fallback values so app can still function
      setCompanySettings({
        companyName: 'Pacific RBS Ltd',
        companyLegalName: 'Pacific RBS Limited',
        companyAbbreviation: 'PRBS',
        primaryColor: '#3b82f6',
        secondaryColor: '#10b981'
      });
    } finally {
      setLoading(false);
    }
  };

  const refreshSettings = async () => {
    await loadCompanySettings();
  };

  const value = {
    companySettings,
    loading,
    error,
    refreshSettings
  };

  return (
    <CompanySettingsContext.Provider value={value}>
      {children}
    </CompanySettingsContext.Provider>
  );
};

export default CompanySettingsContext;